import { render, staticRenderFns } from "./save-order.vue?vue&type=template&id=fb2671ca&scoped=true&"
import script from "./save-order.vue?vue&type=script&lang=js&"
export * from "./save-order.vue?vue&type=script&lang=js&"
import style0 from "./save-order.vue?vue&type=style&index=0&id=fb2671ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2671ca",
  null
  
)

component.options.__file = "save-order.vue"
export default component.exports